import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_45: FaireProductEntity = {
  token: "catalog_prod_prod-45",
  type: "product",
  name: "River Stone Mortar And Pedestal",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 91.8,
  msrpDollars: 229.5,
  sku: "JA0045",
  caseSize: 3,
  material: "Wood",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 85,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_gift-wrapping"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
